import {
    CATALOGUE_CONTENT_TYPE_BY_EXTENSION,
    CATALOGUE_DEFAULT_CONTENT_TYPE,
} from '../constants/catalogue';
import { AWS_S3 } from 'src/constants/crm/aws';
import type { CatalogueDocument } from '../types/catalogue';

export const limitCatalogueCharacters = (inputString: string, limit: number) => {
    if (inputString.length > limit) {
        return `${inputString.substring(0, limit)}...`;
    }
    return inputString;
};

export const getCatalogueMediaUrl = (file?: string) =>
    file?.trim() ? `${AWS_S3}${file.trim()}` : undefined;

export const getCatalogueContentType = (file?: string) => {
    if (!file?.trim()) return undefined;

    const extension = file.split('.').pop()?.toLowerCase();

    return extension
        ? CATALOGUE_CONTENT_TYPE_BY_EXTENSION[extension] ||
        CATALOGUE_DEFAULT_CONTENT_TYPE
        : CATALOGUE_DEFAULT_CONTENT_TYPE;
};

export const buildCatalogueMessage = (document: CatalogueDocument) => {
    const lines: string[] = [];
    const hasModel = Boolean(document.model?.trim());
    const hasPrice = Boolean(document.price?.trim());
    const hasDescription = Boolean(document.description?.trim());
    const hasLink = Boolean(document.link?.trim());

    if (hasModel || hasPrice) {
        const parts: string[] = [];
        if (hasModel) parts.push(document.model!.trim());
        if (hasPrice) parts.push(`$${document.price!.trim()}`);
        lines.push(parts.join(' - '));
    }

    if (hasDescription) lines.push(document.description!.trim());
    if (hasLink) lines.push(document.link!.trim());

    return lines.join('\n');
};
